import React, { useState } from 'react';
import { Button, Spinner } from "react-bootstrap";
import _ from "lodash";
import truncateString from "../../utils/truncateString";
import { getSimpleIconByName } from "../../assets/icons";
import { getThumbnailUrlForItem } from "../../utils/common";
import './ProcessingItem.scss';

const ProcessingItem = props => {
  const [isDeleting, setIsDeleting] = useState(false);
  const renderThumbnailImage = () => {
    let imageUrl = null;

    imageUrl = getThumbnailUrlForItem(props.item);

    if (imageUrl) {
      return <img className="thumbnail-image" src={imageUrl} alt="no content" />;
    } else {
      return <div className="file-icon"><img src={getSimpleIconByName(props.item.ext)} alt="file icon" /></div>
    }
  }

  const onRemoveIem = (itemId) => {
    setIsDeleting(true);
    props.onRemove(props.item.id);
  }

  const titleLong = _.get(props.item, 'meta.contentTitle', _.get(props.item, 'original.original_basename'));
  const titleShort = truncateString(titleLong, 45);

  return (
    props.isLoading ?
      <div className="collection-processing-item increase-size items-center justify-center">
        <div className="overflow-ellipsis whitespace-nowrap overflow-hidden max-w-full">Adding {titleShort}</div>
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      </div>
      :
      <div className="collection-processing-item increase-size justify-between">
        <div className="item-header">
          {/* <div className="file-icon">
            <img src={getSimpleIconByName(props.item.ext)} alt="file icon" />
          </div> */}
          {renderThumbnailImage()}
          <span className="details">{titleShort}</span>
        </div>
        <div className="processing-status">
          <Button
            type="submit"
            variant="outline-danger"
            size="sm"
            onClick={() => onRemoveIem(props.item.id)}
            disabled={isDeleting}
          >
            {isDeleting ?
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              /> : 'Remove'
            }
          </Button>
        </div>
      </div>
  )
}

export default ProcessingItem;
